import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { api } from "../../services/api";
import Swal from "sweetalert2";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer";

export default function ImportadorPromocao() {
    const [uploading, setUploading] = useState(false);
    const [workbook, setWorkbook] = useState(null);
    const [abas, setAbas] = useState([]);
    const [abaSelecionada, setAbaSelecionada] = useState("");
    const [dadosParaExibir, setDadosParaExibir] = useState([]);

    const handleFile = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Inicia Loading para leitura do Excel
        Swal.fire({
            title: 'Lendo arquivo...',
            text: 'Aguarde enquanto processamos a planilha',
            allowOutsideClick: false,
            didOpen: () => { Swal.showLoading(); }
        });

        const reader = new FileReader();
        reader.onload = (evt) => {
            try {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });
                setWorkbook(wb);
                setAbas(wb.SheetNames);
                setAbaSelecionada("");
                setDadosParaExibir([]);
                Swal.close(); // Fecha o loading
            } catch (err) {
                Swal.fire("Erro", "Falha ao ler o arquivo Excel", "error");
            }
        };
        reader.readAsBinaryString(file);
    };

    const handleSelecaoAba = (e) => {
        const nomeAba = e.target.value;
        setAbaSelecionada(nomeAba);
        if (nomeAba) {
            const ws = workbook.Sheets[nomeAba];
            // defval: 0 ajuda a evitar campos nulos virem vazios
            const data = XLSX.utils.sheet_to_json(ws, { defval: "" });
            setDadosParaExibir(data);
        } else {
            setDadosParaExibir([]);
        }
    };

    const processarEnvio = async () => {
        const { isConfirmed } = await Swal.fire({
            title: 'Confirmar Importação',
            text: `Deseja importar ${dadosParaExibir.length} promoções?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, importar'
        });

        if (!isConfirmed) return;

        setUploading(true);
        
        // Mostra loading de envio
        Swal.fire({
            title: 'Sincronizando...',
            text: 'Enviando dados para o servidor, isso pode levar alguns segundos.',
            allowOutsideClick: false,
            didOpen: () => { Swal.showLoading(); }
        });

        try {
            await api.post('/promocao/importar', dadosParaExibir);
            Swal.fire("Sucesso", "Dados sincronizados com sucesso!", "success");
            setDadosParaExibir([]);
            setAbas([]);
            setAbaSelecionada("");
        } catch (error) {
            Swal.fire("Erro", error.response?.data?.error || error.message, "error");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="d-flex flex-column min-vh-100 bg-white">
            <Menu modulo="PROMO" />
            <main className="flex-grow-1 d-flex flex-column" style={{ marginTop: '60px' }}>
                <div className="border-bottom bg-light px-3 py-2">
                    <div className="row g-2 align-items-center">
                        <div className="col-auto">
                            <input 
                                type="file" 
                                id="fileInput"
                                className="d-none" 
                                accept=".xlsx, .xls"
                                onChange={handleFile}
                            />
                            <button 
                                className="btn btn-sm btn-outline-secondary fw-bold"
                                onClick={() => document.getElementById('fileInput').click()}
                                disabled={uploading}
                            >
                                <i className="fas fa-file-excel me-2"></i>Escolher Planilha
                            </button>
                        </div>

                        {abas.length > 0 && (
                            <div className="col-auto d-flex align-items-center">
                                <span className="small me-2 fw-bold text-danger">Guia:</span>
                                <select 
                                    className="form-select form-select-sm border-danger" 
                                    style={{ width: '200px' }}
                                    value={abaSelecionada} 
                                    onChange={handleSelecaoAba}
                                    disabled={uploading}
                                >
                                    <option value="">Selecione...</option>
                                    {abas.map(n => <option key={n} value={n}>{n}</option>)}
                                </select>
                            </div>
                        )}

                        {dadosParaExibir.length > 0 && (
                            <div className="col-auto ms-auto">
                                <button 
                                    className="btn btn-sm btn-success fw-bold" 
                                    onClick={processarEnvio}
                                    disabled={uploading}
                                >
                                    <i className={`${uploading ? 'fas fa-spinner fa-spin' : 'fas fa-sync'} me-2`}></i>
                                    {uploading ? 'Processando...' : `Sincronizar ${dadosParaExibir.length} itens`}
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div className="flex-grow-1 overflow-hidden d-flex flex-column">
                    {dadosParaExibir.length > 0 ? (
                        <div className="table-responsive flex-grow-1">
                            <table className="table table-sm table-hover table-striped mb-0" style={{ fontSize: '0.75rem' }}>
                                <thead className="table-dark sticky-top">
                                    <tr>
                                        {Object.keys(dadosParaExibir[0]).map(key => (
                                            <th key={key} className="px-2 py-1 text-uppercase border-end border-secondary">{key}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {dadosParaExibir.map((item, idx) => (
                                        <tr key={idx}>
                                            {Object.values(item).map((val, i) => (
                                                <td key={i} className="px-2 py-1 text-nowrap border-end">{String(val)}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="m-auto text-center text-muted">
                            <i className="fas fa-upload fa-3x mb-3 opacity-25"></i>
                            <p>Carregue o arquivo para visualizar os dados</p>
                        </div>
                    )}
                </div>
            </main>
            <Footer />
        </div>
    );
}